module.exports = __webpack_public_path__ + "93235ccab204f7618307dbd3ed396a97.png";